import React from "react"
import ActiveAvatar from "avatar/klaus-ship.svg"
import InactiveAvatar from "avatar/klaus-ship-inactive.svg"

const KlausShip = ({ inactive, className = "", ...rest }) => {
  if (inactive) {
    return <img src={InactiveAvatar} className={`inactive ${className}`} {...rest} />
  }
  return <img src={ActiveAvatar} className={className} {...rest} />
}

export default KlausShip
